import { Theme, makeStyles } from "@material-ui/core";

export const useStyle = makeStyles((theme: Theme) => ({
  container: {
    width: "84px",
    borderRadius: "8px",
    background: "white",
    padding: "12px 0px",
    border: "1px solid #D9E7F0",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Lato",
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
  },
  big: {
    width: "100px",
    padding: "24px 0!important",
  },
  small: {
    height: "40px",
    padding: "24px",
  },
  selected: {
    background: "#ECF3F8",
  },
  title: {
    color: "#747F9D;",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: "140%",
  },
  content: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: "Lato",
    fontWeight: 500,
    lineHeight: "24px",
    color: "black",
  },
  footer: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 600,
    color: "#00A3A3",
    lineHeight: "140%",
  },
}));
